import { Action } from '@ngrx/store';
import { MonitorViewType } from '../../monitor/models/monitor';
import { MemberPriority, RetailPriority } from '../../monitor/models/priority';
import { CompanyType } from '../../monitor/models/company';

export enum MonitorActionTypes {
  SetViewType = '[Monitor] Set view type',
  SetSelectedMaturityId = '[Monitor] Set selected maturity id',
  SetFilterByCompanyType = '[Monitor] Set filter by company type',
  SetFilterByMemberPriority = '[Monitor] Set filter by member priority',
  SetFilterByRetailPriority = '[Monitor] Set filter by retail priority'
}

export class SetMonitorViewType implements Action {
  public readonly type: string = MonitorActionTypes.SetViewType;
  public readonly location: boolean = true; // ToDo: Not sure if we need

  constructor(public payload: MonitorViewType) {}
}

export class SetSelectedMaturityId implements Action {
  public readonly type: string = MonitorActionTypes.SetSelectedMaturityId;
  public readonly location: boolean = true; // ToDo: Not sure if we need

  constructor(public payload: string) {}
}

export class SetFilterByCompanyType implements Action {
  public readonly type: string = MonitorActionTypes.SetFilterByCompanyType;

  constructor(public payload?: CompanyType) {}
}

export class SetFilterByMemberPriority implements Action {
  public readonly type: string = MonitorActionTypes.SetFilterByMemberPriority;

  constructor(public payload?: MemberPriority) {}
}

export class SetFilterByRetailPriority implements Action {
  public readonly type: string = MonitorActionTypes.SetFilterByRetailPriority;

  constructor(public payload?: RetailPriority) {}
}

export type MonitorActionUnion =
  | SetMonitorViewType
  | SetSelectedMaturityId
  | SetFilterByCompanyType
  | SetFilterByMemberPriority
  | SetFilterByRetailPriority;
